import { useEffect } from 'react';
import {
  useStoreActions,
  useStoreRehydrated,
  useStoreState,
} from '@discover-data/stores/restaurant/hooks';
import useHasLastTableQueryState from './useQueryState';

/**
 * Sync the router state value to the restaurant store
 */
export default function useSyncHasLastTable() {
  const rehydrated = useStoreRehydrated();
  const storeValue = useStoreState((state) => state.hasLastTable.value);
  const setStoreValue = useStoreActions((actions) => actions.hasLastTable.set);
  const [routerValue] = useHasLastTableQueryState();

  useEffect(() => {
    if (!rehydrated) {
      return;
    }

    // only set if the value changed
    if (routerValue !== storeValue) {
      setStoreValue(routerValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rehydrated, routerValue]); // we only care about changes to the router value
}
